
/**
 * 业务http服务
 *  showErr: [false], true 时自动 show 错误信息, 开发模式下自动显示
 *  handleError|throwError: [false], true 错误时返回给用户自己处理
 *  opt: {params}, params 会 qs 成 query 参数
 *
 */
import { rp } from "./rp.js"
import { showNotify } from "@/utils/show"
import { isDev, urlPrefix } from "@/configs/public"

function show(err) {
  let code = err.data?.code || err.code || err.status || ""
  let message = err.data?.message || err.message || err.statusText || err
  if (code === 500) message = "后台服务异常，请与管理员联系"
  else if (code) message = `${code}:${message}`
  console.log("http msg:", message)
  showNotify(message, 'error')
}


/**
 * Base类封装业务相关的 HTTP 请求，Base是父类
 * prefix 请求的 URL 前缀
 */
export class Base {
  // accessToken
  prefix = urlPrefix

  // 构造函数接收一个配置对象，可以通过该对象来设置 prefix 的值。
  constructor({ prefix } = {}) {
    prefix !== undefined && (this.prefix = prefix)
  }

  get(url, opt) {
    return this.http({ url, ...opt, method: "GET" })
  }
  post(url, data, opt) {
    return this.http({ url, data, ...opt, method: "POST" })
  }
  put(url, data, opt) {
    return this.http({ url, data, ...opt, method: "PUT" })
  }
  delete(url, opt) {
    return this.http({ url, ...opt, method: "DELETE" })
  }

  async http({ url, showErr, throwError = true, ...opt }) {
    this.prefix && (url = this.prefix + url)
    try {
      let res = await rp(url, { ...opt }) // 服务器的信息；
      if (res?.code && (showErr || isDev)) {
        show(res)
      }
      if (res?.code && throwError) throw res
      return res
    } catch (error) {
      console.error('base http err:', error)
      // "Failed to execute 'json' on 'Response': Unexpected end of JSON input"
      if (error !== 'toLogin'
        && error?.message !== "Failed to execute 'json' on 'Response': Unexpected end of JSON input"
      ) show(error?.message === 'Failed to fetch' ? '网络联接异常，请重试:' : error?.message)
      throw error
    }
  }

  async add(data, url = "") {
    return this.post(url, data)
  }

  async remove(id, url = "") {
    return this.delete(url, { params: { id } })
  }

  async update(data, url = "") {
    return this.post(url, data)
  }

  async getInfo(query, url = "") {
    return this.get(url, { data: query })
  }
}
